const moduleMap = {
	".": () => {
		return Promise.all([__webpack_require__.e(6205), __webpack_require__.e(9541), __webpack_require__.e(62), __webpack_require__.e(468), __webpack_require__.e(2971), __webpack_require__.e(9084), __webpack_require__.e(3404), __webpack_require__.e(1141), __webpack_require__.e(6557), __webpack_require__.e(9024), __webpack_require__.e(2497), __webpack_require__.e(3403), __webpack_require__.e(5987), __webpack_require__.e(3788), __webpack_require__.e(4389), __webpack_require__.e(3761), __webpack_require__.e(3086), __webpack_require__.e(2422), __webpack_require__.e(6662), __webpack_require__.e(1926), __webpack_require__.e(9972), __webpack_require__.e(7918), __webpack_require__.e(7167), __webpack_require__.e(1736), __webpack_require__.e(8918), __webpack_require__.e(6113), __webpack_require__.e(428), __webpack_require__.e(1061), __webpack_require__.e(4026), __webpack_require__.e(3534), __webpack_require__.e(6890), __webpack_require__.e(3594), __webpack_require__.e(2842), __webpack_require__.e(3838), __webpack_require__.e(7771), __webpack_require__.e(7028), __webpack_require__.e(8958), __webpack_require__.e(1743), __webpack_require__.e(318), __webpack_require__.e(2278), __webpack_require__.e(7487), __webpack_require__.e(9164), __webpack_require__.e(6723), __webpack_require__.e(2097)]).then(() => (() => ((__webpack_require__(82097)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});